import request from '@/utils/axios'

type ApiResp<T = any> = { code: number; message: string; data: T }

export interface ValidCurrUserData {
  valid: boolean
  userInfo?: {
    userId: number
    username: string
    realName: string | null
    role: number
    department: number
    email: string | null
    tel: string | null
    status: number
  }
}

export function validCurrUser() {
  // 你 axios 响应拦截器最后 return res，所以这里拿到的是 {code,message,data}
  return request.get('/common/valid_curr_user') as Promise<ApiResp<ValidCurrUserData>>
}
